module.exports = __webpack_public_path__ + "img/components.5a6a1dc5.svg";